<div class="flex justify-between items-center" [ngClass]="blockClass" (click)="openCalendarEventForm()" role="button"
    *ngIf="event()">
    <div class="flex flex-col gap-3">
        <p class="mb-0" [ngClass]="{'!hidden': !show.includes('label') || !isLabel}">
            <span class="entity-badge text-12-400 color-7">{{
                ss.t('common_calendar') }} - {{ event()!.calendarName }}</span>
        </p>

        <div class="flex flex-col gap-2">
            <p class="text-16-400 color-8 mb-0">{{ event()!.title || '(No Title)' }}</p>
            <div [ngClass]="{'!hidden': descriptionType === 'none' || !event()!.description}" [innerHTML]="descriptionHtml()"
                class="description-content calender-block-text-editor color-7"></div>
        </div>

        <div class="flex gap-3 flex-wrap"
            [ngClass]="{'!hidden': ((!show.includes('time') || !event()!.startTime) && (!show.includes('reminder') || !event()!.reminderAt || event()!.reminderAt.length === 0 || !event()!.startTime) && (!show.includes('duration') || !event()!.startTime) && (!show.includes('attachments') || !event()!.attachments || event()!.attachments.length === 0) && !show.includes('calendarName'))}"
>
            <div class="inline-flex items-center gap-1.5"
                *ngIf="show.includes('time') && event()!.startTime">
                <app-svg name="clock" [color]="ss.theme().color7"
                    width="12" height="12"></app-svg>
                <span class="text-12-400 color-7">{{ resolvedTimeStr() }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5"
                *ngIf="show.includes('reminder') && event()!.reminderAt && event()!.reminderAt.length > 0 && event()!.startTime">
                <app-svg name="bell" [color]="ss.theme().color7"
                    width="12" height="12"></app-svg>
                <span class="text-12-400 color-7"><span *ngFor="let reminder of event()!.reminderAt;let i = index;">{{
                        ds.getReminderText(reminder) }}<span *ngIf="i < event()!.reminderAt.length - 1">,
                        </span></span></span>
            </div>
            <div class="inline-flex items-center gap-1.5"
                *ngIf="show.includes('duration') && event()!.startTime">
                <app-svg name="timer" [color]="ss.theme().color7"
                    width="12" height="12"></app-svg>
                <span class="text-12-400 color-7">{{ event()!.duration | parseMinutes }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5"
                *ngIf="show.includes('attachments') && event()!.attachments && event()!.attachments.length > 0">
                <app-svg name="attachment" [color]="ss.theme().color7"
                    width="12" height="12"></app-svg>
                <span class="text-12-400 color-7">{{ event()!.attachments.length }}</span>
            </div>
            <div class="inline-flex items-center gap-1.5" *ngIf="show.includes('calendarName')">
                <app-svg name="calendarIntegration" [color]="ss.theme().color7"
                    width="12" height="12"></app-svg>
                <span class="text-12-400 color-7">{{ event()!.calendarName }}</span>
            </div>
        </div>
    </div>
    <div>
        <app-svg name="calendarIntegration" [color]="ss.theme().color7"></app-svg>
    </div>
</div>